<template>
  <div class="basic-activation">
    <div class="row">
      <!-- INPUT DE NOME DE EXIBIÇÃO -->
      <PmwFormInput
        :value="displayNameValue"
        :showCounter="true"
        :hasLanguages="true"
        :infoIcon="true"
        :language="language"
        :languageCodes="{ pt: 'pt-BR', en: 'en-US', es: 'es-ES' }"
        maxlength="100"
        tooltipMinWidth="437"
        label="Nome de exibição para os hóspedes"
        placeholder="Ex: Oferta de aniversário"
        infoText="Defina o nome que será exibido aos usuários para esta condição, nas diferentes possibilidades de idiomas. Caso estes valores fiquem em branco, o nome utilizado para exibição será o respectivo nome interno desta tarifa."
        class="form--input__name"
        id="form--name"
        @changeLanguage="language = $event"
        @input="displayNameHandler"
      />

      <!-- CHECKBOX DE TARIFA PRIORITÁRIA -->
      <InputCheckbox
        v-model="fluctuationData.prioritaria"
        :checked="fluctuationData.prioritaria"
        :inputValue="true"
        :infoIcon="true"
        tooltipMinWidth="306"
        label="Tarifa prioritária"
        infoText="Quando selecionado, faz com o que esta tarifa tenha mais destaque, ocultando as não-prioritárias."
        name="priorityTariff"
        class="form--input__select"
      />
    </div>

    <div id="row">
      <div class="form--row">
        <!-- INPUT DE NOME INTERNO -->
        <PmwFormInput
          v-model="fluctuationData.nome"
          :infoIcon="true"
          :showCounter="true"
          :required="true"
          :error="errors.includes('Nome')"
          data-error="Nome"
          maxlength="50"
          tooltipMinWidth="257"
          infoText="Define o nome de identificação interno desta tarifa para a área de administração"
          label="Nome interno"
          placeholder="Digite um nome"
          class="form--input__internalName"
        />

        <!-- INPUT DE PMS -->
        <PmwFormInput
          v-model="fluctuationData.codigoPMS"
          :infoIcon="true"
          maxlength="15"
          label="Código PMS"
          tooltipMinWidth="236"
          infoText="Para integrações com PMS, define o código externo desta tarifa no sistema do hotel."
          placeholder="0000000"
          class="form--input__pms"
        />

        <!-- INPUT PENSAO -->
        <PmwFormSelect
          v-model="tipoPensao"
          :options="pensaoTypeOptions"
          :infoIcon="true"
          :required="isPensionMandatory"
          tooltipMinWidth="236"
          infoText="Pensão é obrigatório para hotéis integrados com Hits e Alpha"
          class="form--input form--input__select"
          size="small"
          label="Pensão"
          placeholder="Selecione um tipo"
        />

        <!-- CATEGORIAS TARIFÁRIAS -->
        <PmwFormSelect
          v-model="categoriaTarifaria"
          :options="categoriaTarifariaOptions"
          :infoIcon="true"
          tooltipMinWidth="236"
          infoText="Defina uma categoria para suas regras
        tarifárias, facilitando a filtragem."
          class="form--input
        form--input__select"
          size="small"
          label="Categorias tarifárias"
          placeholder="Selecione uma categoria"
          @input="categoriaTarifariaHandler"
        />
      </div>

      <div class="form--row">
        <!-- INPUT DE TIPO DE PREÇO BASE -->
        <PmwFormSelect
          v-model="basePriceType"
          :options="basePriceTypeOptions"
          :required="true"
          :search="true"
          tooltipMinWidth="165"
          label="Tipo de preço base"
          placeholder="Selecione um tipo"
          class="form--input form--input__select"
          @input="basePriceTypeHandler"
        />

        <!-- SELEÇÃO DE TARIFA BASE -->
        <PmwFormSelect
          v-if="
            baseRateOptions.length > 1 &&
              getTarifarioAbsoluto &&
              basePriceType?.value === 0
          "
          :value="baseRateValue"
          :options="baseRateOptions"
          :search="true"
          :required="baseRateOptions.length >= 2"
          :error="errors.includes('CodigoTarifaBase')"
          data-error="CodigoTarifaBase"
          label="Selecione a tarifa base"
          placeholder="Selecione a tarifa"
          class="form--input form--input__select"
          @input="selectBaseRateHandler"
        />

        <PmwFormInput
          v-if="!showCoefficientPerDay && basePriceType.value === 0"
          v-only-numbers
          v-model.number="fluctuationData.coeficiente"
          :required="true"
          :error="errors.includes('Coeficiente')"
          data-error="Coeficiente"
          sufix="%"
          type="number"
          label="Coeficiente"
          placeholder="100"
          class="form--input__coefficient"
          @blur="coeficienteHandler"
        />

        <!-- INFORMAÇÕES COEFICIENTE -->
        <PmwParagraph
          v-if="basePriceType.value === 0"
          class="link"
          size="paragraph-40"
        >
          Colocando 100%, sua tarifa terá o valor da tarifa base.
        </PmwParagraph>
      </div>

      <!-- CALENDÁRIO ABSOLUTO -->
      <div v-if="basePriceType.value === 1" class="form--row">
        <AbsoluteCalendar
          v-for="room in fluctuationData.precosQuartos"
          :key="`room-${room.codigoQuarto}`"
          :fluctuationData="fluctuationData"
          :guestValues="room.valoresOcupantes"
          :roomCode="room.codigoQuarto"
          :roomName="
            hotelRoomsData.find((item) => item.codigo === room.codigoQuarto)
              ?.nome
          "
        />
      </div>

      <!-- CHECKBOX DE EXIBIR DESCONTO -->
      <div class="form--row">
        <InputCheckbox
          v-model="fluctuationData.exibeDesconto"
          :checked="fluctuationData.exibeDesconto"
          :inputValue="true"
          :infoIcon="true"
          tooltipMinWidth="325"
          label="Exibir desconto"
          infoText="Se o checkbox estiver ativo, o valor exibido na no site será com informações sobre descontos e valores cheios."
          name="showDiscount"
          class="form--input__select"
        />
      </div>

      <div v-if="basePriceType.value === 0">
        <!-- CONTROLA A EXIBIÇÃO DO COEFICIENTE POR DIA DE HOSPEDAGEM -->
        <div class="form--title">
          <PmwHeading size="paragraph-80" weight="weight-light">
            Coeficiente por dia da hospedagem
          </PmwHeading>
        </div>

        <div class="form--row">
          <PmwButton
            v-if="!showCoefficientPerDay"
            :hasIcon="true"
            layout="outline"
            variation="blue-100"
            class="form--button"
            @click="addCoefficientPerDay"
          >
            Adicionar coeficiente
          </PmwButton>
        </div>
      </div>

      <!-- COMPONENTE DO COEFICIENTE -->
      <div
        v-if="
          showCoefficientPerDay && fluctuationData.coeficienteDiasSemana?.length
        "
        class="form--row"
      >
        <CoefficientPerDay
          v-model="fluctuationData.coeficienteDiasSemana"
          :showCoefficientPerDay="showCoefficientPerDay"
          :errors="errors"
          @closeCoefficientPerDay="closeCoefficientPerDayHandler"
        />
      </div>

      <!-- MODAL DE AVISO DE VALOR PREENCHIDO -->
      <InputModalAlert
        :show="showCoefficientAlert"
        firstLine="O valor preenchido foi menor que 50%."
        mainText="Lembre-se que o coeficiente é a porcentagem referente ao valor do calendário, e não a porcentagem de desconto."
        lastLine="Tem certeza que quer continuar?"
        @closeAlert="showCoefficientAlert = false"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import CoefficientPerDay from './CoefficientPerDay.vue'
import AbsoluteCalendar from './AbsoluteCalendar.vue'
import InputModalAlert from '../InputModalAlert.vue'
import debounce from 'lodash.debounce'
import OnlyNumbersDirective from '@/directives/OnlyNumbersDirective'

export default {
  name: 'BasicActivation',
  directives: {
    'only-numbers': OnlyNumbersDirective
  },
  components: {
    PmwFormInput,
    PmwFormSelect,
    InputCheckbox,
    PmwParagraph,
    PmwHeading,
    PmwButton,
    CoefficientPerDay,
    AbsoluteCalendar,
    InputModalAlert
  },
  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    reloadAbsolute: {
      type: Boolean,
      default: false
    },

    showDiscount: {
      type: Boolean,
      default: false
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    },

    baseRateOptions: {
      type: Array,
      default: () => []
    },

    hotelPms: {
      type: String,
      default: ''
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /** Linguagem selecionada */
      language: 'pt-BR',

      showCoefficientAlert: false,

      showCoefficientPerDay: false,

      /** Valor selecionado no preço base */
      basePriceType: { value: 0, text: 'Flutuante' },

      basePriceTypeOptions: [
        { value: 0, text: 'Flutuante' },
        { value: 1, text: 'Absoluto' }
      ],

      originalCoeficienteDiasSemana: [],

      tipoPensao: null,

      categoriaTarifaria: null,

      pensaoTypeOptions: [
        { value: 1, text: 'Sem pensão' },
        { value: 2, text: 'Café da manhã' },
        { value: 3, text: 'MAP' },
        { value: 4, text: 'FAP' },
        { value: 5, text: 'All inclusive' }
      ],

      categoriaTarifariaOptions: [{ value: null, text: 'Nenhuma categoria' }]
    }
  },

  computed: {
    ...mapGetters('hotel', ['getTarifarioAbsoluto']),
    /** Retorna o nome do idioma selecionado */
    displayNameValue() {
      return this.fluctuationData.idiomas.find(
        (item) => item.idioma === this.language
      )?.nome
    },

    /** Retorna o valor da tarifa base */
    baseRateValue() {
      return this.baseRateOptions.find(
        (item) => item.value === this.fluctuationData.codigoTarifaBase
      )
    },

    /** Se o hotel tiver PMS "Hits" ("APP") ou "Alpha" ("ALP") o campo "Pensão" deve ser obrigatório */
    isPensionMandatory() {
      return this.hotelPms === 'APP' || this.hotelPms === 'ALP'
    }
  },

  watch: {
    tipoPensao(newValue) {
      this.fluctuationData.tipoPensao = newValue ? newValue.value : null
    },

    hotelRoomsData(newVal) {
      if (newVal?.length) {
        this.absoluteDataHandler()
      }
    },

    reloadAbsolute() {
      this.absoluteDataHandler()
    },

    basePriceType(newValue) {
      if (newValue.value > 0) {
        if (!this.hotelRoomsData?.length) {
          this.$emit('load-hotel-rooms-data')
        }

        if (
          newValue.value === 1 &&
          !this.fluctuationData.precosQuartos?.length
        ) {
          this.absoluteDataHandler()
        }

        this.fluctuationData.coeficienteDiasSemana = []
        this.showCoefficientPerDay = false
      } else {
        this.fluctuationData.coeficiente = 100
        this.fluctuationData.precosQuartos = []
      }
    },

    fluctuationData() {
      if (this.fluctuationData.coeficienteDiasSemana?.length) {
        this.originalCoeficienteDiasSemana = this.fluctuationData.coeficienteDiasSemana
        this.addCoefficientPerDay()
      }

      if (this.fluctuationData.precosQuartos?.length > 0) {
        this.basePriceType = { value: 1, text: 'Absoluto' }
      }
      if (this.fluctuationData.tipoPensao) {
        const selected = this.pensaoTypeOptions.find(
          (option) => option.value === this.fluctuationData.tipoPensao
        )
        this.tipoPensao = selected || null
      }

      this.categoriaTarifaria = this.categoriaTarifariaOptions.find(
        (option) => option.value === this.fluctuationData?.codigoCategoria
      )
    },

    showCoefficientPerDay(newValue) {
      if (newValue && !this.fluctuationData.coeficienteDiasSemana?.length) {
        this.fluctuationData.coeficienteDiasSemana = Array.from(
          { length: 7 },
          (v, i) => {
            return { diaSemana: i, coeficiente: null }
          }
        )
      }
    }
  },

  created() {
    this.fluctuationData.codigoHotel = +this.$route.params.id

    if (this.baseRateOptions?.length === 1) {
      this.fluctuationData.codigoTarifaBase = this.baseRateOptions[0].value
    }

    this.getCategories()
  },

  methods: {
    categoriaTarifariaHandler($event) {
      this.fluctuationData.codigoCategoria = $event.value
    },

    getCategories() {
      this.$rate.getRateRuleCategories().then(({ data }) => {
        this.categoriaTarifariaOptions.push(
          ...data
            .filter((item) => item.ativo)
            .map((item) => ({
              text: item.nome,
              value: item.codigo
            }))
        )

        if (this.fluctuationData.codigoCategoria) {
          this.categoriaTarifaria = this.categoriaTarifariaOptions.find(
            (option) => option.value === this.fluctuationData.codigoCategoria
          )
        }
      })
    },

    absoluteDataHandler() {
      if (
        !this.fluctuationData.precosQuartos?.length &&
        this.basePriceType?.value > 0
      ) {
        const sortedHotelRoomData = [...this.hotelRoomsData]

        sortedHotelRoomData.sort((a, b) => a.codigo - b.codigo)

        /* Ordena os quartos pelo código */
        this.fluctuationData.precosQuartos = this.createRoomsPriceObj(
          sortedHotelRoomData
        )
      } else if (this.fluctuationData.precosQuartos?.length) {
        const customHotelData = this.createRoomsPriceObj([
          ...this.hotelRoomsData
        ])

        customHotelData.forEach((itemRoom) => {
          if (itemRoom.valoresOcupantes.length >= 1) {
            const matchingItem = this.fluctuationData.precosQuartos.find(
              (item) => item.codigoQuarto === itemRoom.codigoQuarto
            )

            if (matchingItem) {
              itemRoom.valoresOcupantes.forEach((occupant) => {
                const matchingOccupant = matchingItem.valoresOcupantes.find(
                  (item) =>
                    item.numeroOcupantes === occupant.numeroOcupantes &&
                    item.tipoPax === occupant.tipoPax
                )

                if (matchingOccupant && matchingOccupant.valor !== null) {
                  occupant.valor = matchingOccupant.valor
                }
              })

              Object.assign(matchingItem, itemRoom)
            }
          }
        })

        this.fluctuationData.precosQuartos = customHotelData

        /* Ordena os quartos pelo código */
        this.fluctuationData.precosQuartos = this.fluctuationData.precosQuartos.sort(
          (a, b) => a.codigoQuarto - b.codigoQuarto
        )
      }
    },

    /** Validar valor do coeficiente */
    coeficienteHandler: debounce(function() {
      if (
        this.fluctuationData.coeficiente <= 50 &&
        this.basePriceType.value === 0 &&
        !this.showCoefficientPerDay
      ) {
        this.showCoefficientAlert = true
      }
    }, 500),

    addCoefficientPerDay() {
      this.showCoefficientPerDay = true
      this.fluctuationData.coeficiente = 100

      this.fluctuationData.coeficienteDiasSemana = this.originalCoeficienteDiasSemana
    },

    /** Manipula a mudança de valores do nome */
    displayNameHandler($event) {
      const langMatch = this.fluctuationData.idiomas.find(
        (item) => item.idioma === this.language
      )

      if (langMatch) {
        this.$set(langMatch, 'nome', $event)
      } else {
        this.fluctuationData.idiomas.push({
          idioma: this.language,
          nome: $event
        })
      }
    },

    /** Manipula mudança de valores do tipo de preço base */
    basePriceTypeHandler($event) {
      const { value } = $event

      this.fluctuationData.tipoCoeficiente = value
    },

    /** Manipula a seleção de tarifa base */
    selectBaseRateHandler($event) {
      const { value: rateCode } = $event

      this.fluctuationData.codigoTarifaBase = rateCode
    },

    /**
     * Cria o conteúdo da chave `precosQuartos`
     * @param {object} rooms Objeto com os dados dos quartos do hotel
     *
     * @return {object[]} Array de objetos
     */
    createRoomsPriceObj(rooms) {
      /**
       * precosQuartos: [
          {
            codigoQuarto: 0,
            valoresOcupantes: [
              {
                numeroOcupantes: 0,
                valor: 0,
                tipoPax: 10
              }
            ]
          }
        ]
        */
      return rooms.reduce((acc, item) => {
        if (item.ativo) {
          acc.push({
            codigoQuarto: item.codigo,
            valoresOcupantes: this.getRoomGuestsObjects(item)
          })
        }

        return acc
      }, [])
    },

    /** Extraí os campos de hóspedes para setar o valor absoluto */
    getRoomGuestsObjects(room) {
      const adults = this.getPaxObj(10, room.maximoAdultos)

      const children = this.getPaxObj(8, room.maximoCriancas)

      return [...adults, ...children]
    },

    /**
     * Retorna os valores de um determinado pax
     * @param {number} pax Código do pax `8 - Criança, 10 - Adulto`
     * @param {number} len Quantidade máxima do tipo do pax para o quarto
     */
    getPaxObj(pax, len) {
      const paxArr = []

      for (let i = 1; i <= len; i++) {
        paxArr.push({
          numeroOcupantes: i,
          valor: null,
          tipoPax: pax
        })
      }

      return paxArr
    },

    closeCoefficientPerDayHandler() {
      this.showCoefficientPerDay = false
      this.fluctuationData.coeficienteDiasSemana = []
      this.fluctuationData.coeficiente = 100
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-input__disabled {
      input {
        background: pmw-colors('grey-20');
        color: $pmw-gray-darker;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
  &.disabled {
    opacity: unset;
    filter: unset;
    pointer-events: unset;

    &::v-deep {
      .pmw-form-field--label,
      .pmw-form-field--asterisk {
        color: $pmw-gray-mid;
      }

      .pmw-input,
      .pmw-input input {
        filter: grayscale(1);
        pointer-events: none;
        background: $pmw-gray-bg;
      }
    }
  }
}

.form {
  &--button {
    max-width: 185px;
    width: 185px;
  }

  &--input {
    max-width: 248px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }
      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__disabled {
      ::v-deep {
        .pmw-form-field--label,
        .pmw-form-field--asterisk {
          color: $pmw-gray-mid;
        }
        .pmw-select {
          filter: grayscale(1);
          pointer-events: none;
          background: $pmw-gray-bg;
        }
      }
    }

    &__name {
      max-width: 375px;
      margin-bottom: 54px;
      margin-right: 34px;

      ::v-deep {
        .pmw-form-field--language {
          display: none;
        }
      }
    }

    &__select {
      width: 200px;
      max-width: 200px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }

    &__internalName {
      max-width: 252px;
    }

    &__pms {
      max-width: 142px;
    }

    &__coefficient {
      max-width: 160px;
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 60px;
  }

  &--row:last-child {
    margin-bottom: 20px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }
}

.row {
  gap: 24px;
}

.link {
  color: $pmw-blue;
  max-width: 150px;
  line-height: 18px;
  padding-top: 25px;

  &:hover {
    color: $pmw-blue;
    text-decoration: underline;
  }
}
</style>
